import ActionButton from 'components/ActionButton';
import AddInventoryItemOnAddressModal from 'components/AddInventoryItemOnAddressModal';
import React, { useState } from 'react';
import styles from './index.module.scss';

const Header = ({ addressObj, fetchItemsList }) => {
  const [addInventoryItemModalOpen, setAddInventoryItemModalOpen] =
    useState<boolean>(false);

  const toggleModal = () =>
    setAddInventoryItemModalOpen(!addInventoryItemModalOpen);

  return (
    <div className={styles['header']}>
      {addInventoryItemModalOpen && (
        <AddInventoryItemOnAddressModal
          addressObj={addressObj}
          onSuccess={fetchItemsList}
          toggleModal={toggleModal}
        />
      )}
      <div className={styles['heading']}>Inventory Items by Address</div>
      <ActionButton
        text={<>Inventory Item +</>}
        active={true}
        isLoading={false}
        onClick={toggleModal}
      />
    </div>
  );
};

export default Header;
